const googleConfig = {
    clientId: "733187497145-5ugmhchj8e1g2qq5lckg64aftl5l8s16.apps.googleusercontent.com",
    authorizationUri: "https://accounts.google.com/o/oauth2/auth",
    redirectUri: window.location.origin + "/login/dev",
    userInfoUri: "https://openidconnect.googleapis.com/v1/userinfo",
    scopes: ["openid", "profile", "email"]
}

const auth0Config = {
    clientId: "PJgGPlj0YwM4Xc1zpWN2pcAF7KKdNSMN",
    authorizationUri: "https://login-auth0.fednot.be/authorize",
    redirectUri: window.location.origin + "/login",
    userInfoUri: "https://login-auth0.fednot.be/userinfo",
    scopes: ["openid", "profile", "email"]
}

const accessTokenUri = "https://europe-west1-fednot-prod-kennismodule.cloudfunctions.net/get_access_token"

export { accessTokenUri, googleConfig, auth0Config }
